<template>
    <div>
        <el-popover ref="popover" :disabled="!popoverShow" placement="bottom" trigger="click" :width="caseWidth * 1.5" @show="onShowPopover" @hide="onHidePopover">
            <td-tree
                :treeList="treeList"
                :lazyloading="lazyloading"
                :imgloading="imgloading"
                :defaultProps="defaultProps"
                :expandAll="expandAll"
                :height="height"
                :typeContent="typeContent"
                :showBox="showBox"
                :checkStrictly="checkStrictly"
                :inputWidth="inputWidth"
                :nodeKey="nodeKey"
                :inputShow="inputShow"
                :picturePath="picturePath"
                :calInternal="calInternal"
                :isPaging="isPaging"
                :expandOnClick="expandOnClick"
                :isSingleCheck="isSingleCheck"
                :isClick="treeClick"
                :isDbClick="isDbClick"
                ref="TdTree"
                @checkChange="checkChange"
                @check="check"
                @onDbClick="onDbClick"
                @onClick="onClick"
                @queryData="queryData"
                @querySearchData="querySearchData"
                :interfaceName="interfaceName"
                :params="params"
                :isDistributed="isDistributed"
                :customProp="customProp"
                :previewImageUrl="previewImageUrl"
                :token="token"
                :filter="treeFilter"
                :isFilter="isTreeFilter"
                :defaultKey="defaultKey"
            >
            </td-tree>
        </el-popover>
        <div
            :disabled="!popoverShow"
            :class="popoverShow ? 'leave-message-textarea test-1' : 'leave-message-textarea-disabled test-1'"
            :id="divId"
            :style="'height:' + dropTreeHeight + 'px;' + 'width:' + (width - 2) + 'px;readonly:true;background-color:' + (popoverShow ? '' : '')"
            v-popover:popover
            contenteditable="false"
        >
            <span :style="'max-width:' + (width - 100) + 'px;'" class="address-placeholder" v-if="areaUserList.length == 0">
                {{ $t(placeholder) }}
            </span>
            <el-tag size="medium" :closable="popoverShow" v-if="areaUserList.length > 0" :disable-transitions="false" @close="handleClose(areaUserList[0])">
                <span :style="'max-width:' + (width - 100) + 'px'" class="tags-num-text" :title="areaUserList[0][defaultProps.label]">
                    {{ areaUserList[0][defaultProps.label] }}
                </span>
                <span v-if="areaUserList.length > 1" style="max-width:40px;padding-left:10px" class="tags-num-text">+ {{ areaUserList.length - 1 }}</span>
            </el-tag>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        value: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 默认显示内容
        placeholder: {
            type: String,
            default: function() {
                return 'component.PLEASE_SELECT';
            }
        },
        // 树形是否懒加载
        lazyloading: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 下拉树是否显示
        popoverShow: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 下拉树选择框宽度
        width: {
            type: Number,
            default: function() {
                return 200;
            }
        },
        // 树形懒加载数据
        treeList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 搜索框是否显示
        inputShow: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 是否显示树形节点复选框
        showBox: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否显示树形节点图标
        imgloading: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否取消父节点选中后子节点也相继选中
        checkStrictly: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        // 下拉菜单高度
        height: {
            type: Number,
            default: function() {
                return 300;
            }
        },
        defaultProps: {
            type: Object,
            default: function() {
                return {
                    children: 'children',
                    label: 'label',
                    id: 'id',
                    imgName: 'imgName'
                };
            }
        },
        // 树形节点id关键字
        nodeKey: {
            type: String,
            default: function() {
                return 'id';
            }
        },
        // 图标为默认时，读取默认图标路径
        typeContent: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 树节点自定义节点图标
        picturePath: {
            type: Object,
            default: function() {
                return {};
            }
        },
        // 树形节点复选框是否单选
        isSingleCheck: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否使用组件内部方法获取树形数据
        calInternal: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 树形是否分页
        isPaging: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 点击树形节点是否会展开或者收缩节点
        expandOnClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 选择框高度
        dropTreeHeight: {
            type: Number,
            default: function() {
                return 38;
            }
        },
        // 懒加载全部展开
        expandAll: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        isDbClick: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        // 是否多选
        multiple: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 
        需求排除的数据类型
    [{
        field:type,
        value:0
    }]
    */
        // 过滤树形不需要的节点
        treeFilter: {
            type: Array,
            default: function() {
                return [];
            }
        },
        isTreeFilter: {
            type: Boolean,
            default: false
        },
        // 过滤不需要的节点
        filter: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 过滤选择需要的节点类型
        needFilter: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 是否为过滤需要的节点类型
        isNeedFilter: {
            type: Boolean,
            default: false
        },
        // 接口地址
        interfaceName: {
            type: Object,
            default: function() {
                return {
                    query: '',
                    search: ''
                };
            }
        },
        // 是否分布式部署
        isDistributed: {
            type: Boolean,
            default: false
        },
        // 查询参数
        params: Object,
        /* 自定义参数 */
        customProp: {
            type: Array,
            default: function() {
                return [];
            }
        },
        // 图片前置路径
        previewImageUrl: {
            type: String,
            default: function() {
                return '';
            }
        },
        token: {
            type: String
        },
        defaultKey: {
            type: Array,
            default: function() {
                return ['21dsec1d-4a27-48d1-we4c5-e44fcc23110']; // 默认展开组织区域
            }
        }
    },
    data() {
        return {
            areaUserList: [],
            caseWidth: '',
            inputWidth: '',
            lastData: '',
            tagId: '',
            isChosen: true,
            divId: '',
            isDataDisplay: false,
            isExit: false,
            treeClick: this.isClick
        };
    },
    created() {
        this.caseWidth = this.width - 20;
        if (this.width < 170) {
            this.inputWidth = 150;
        } else {
            this.inputWidth = this.width - 20;
        }
        if (!this.multiple) {
            this.showBox = false;
            this.treeClick = true;
        } else {
            this.showBox = true;
        }
        this.divId = this.getUUID();
        /* 增加默认回显 */
        if (this.value.length > 0) {
            this.dataDisplay(this.value);
        }
    },
    mounted() {
        this.$nextTick(function() {
            let menuObj = document.getElementById(this.divId);
            if (this.multiple) {
                menuObj.style.overflowY = 'auto';
            }
            if (!this.popoverShow) {
                // menuObj.style.background = 'red';
            }
        });
    },
    watch: {
        areaUserList: {
            handler: function(val) {
                this.$emit('input', val);
                this.dispatch('ElFormItem', 'el.form.change', val);
            },
            deep: true
        },
        value: {
            handler: function(val) {
                if (!this.isDataDisplay) {
                    var _this = this;
                    this.areaUserList.forEach(item => {
                        if (item[_this.nodeKey] === val[0][_this.nodeKey]) {
                            _this.isExit = true;
                        }
                    });
                    if (!this.isExit) {
                        this.dataDisplay(val);
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        dispatch(componentName, eventName, params) {
            var parent = this.$parent || this.$root;
            var name = parent.$options.componentName;

            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;

                if (parent) {
                    name = parent.$options.componentName;
                }
            }
            if (parent) {
                parent.$emit.apply(parent, [eventName].concat(params));
            }
        },
        // 获取UUID，作为树形divid
        getUUID() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        },
        // 获取选取点的对象数组
        getSelectedNodes() {
            if (this.multiple) {
                let checkedNodes = this.$refs.TdTree.getCheckedNodes();
                return checkedNodes;
            }
            return this.lastData;
        },
        onShowPopover() {
            // let menuObj = document.getElementById(this.divId);
            // this.$nextTick(function() {
            //     menuObj.style.background = 'red';
            // });
            this.$emit('onShowPopover');
        },
        onHidePopover() {
            // let menuObj = document.getElementById(this.divId);
            // this.$nextTick(function() {
            //     // menuObj.style.background = 'white';
            // });
        },
        queryData(parmMap) {
            this.$emit('queryData', parmMap);
        },
        initData(list, initFlag) {
            let checkList = [];
            this.$refs.TdTree.initData(list, checkList, initFlag);
        },
        //初始化树形
        initTree() {
            this.$refs.TdTree.initTree();
        },
        // 数据回显
        dataDisplay(dataList) {
            let checkList = [];
            for (let i in dataList) {
                if (this.$util.isEmpty(dataList[i])) {
                    continue;
                }
                // if (!this.multiple) {
                this.isDataDisplay = true;
                this.areaUserList.push(dataList[i]);
                this.lastData = dataList[i];
                this.onClick(dataList[i]);
                // }
                checkList.push(dataList[i][this.defaultProps.id]);
            }
            if (this.multiple && checkList.length > 0) {
                this.$nextTick(function() {
                    this.$refs.TdTree.defaultSelect(checkList);
                });
            }
            if (Array.isArray(dataList) && dataList.size == 0) {
                this.$nextTick(function() {
                    this.$refs.TdTree.defaultSelect([]);
                });
            }
        },
        //  选择框中数据被关闭时触发事件
        handleClose(tag) {
            for (let i in this.areaUserList) {
                if (this.areaUserList[i][this.defaultProps.id] === tag[this.defaultProps.id]) {
                    this.areaUserList.splice(i, 1);
                    // 删除节点后，重新计算下标
                    i--;
                }
            }
            let childKeyMap = new Map();
            if (!this.checkStrictly) {
                this.getAllChildKeys(tag, childKeyMap);
            }
            if (this.multiple) {
                let checkedKeys = this.$refs.TdTree.getCheckedNodes();
                let checkedNodes = [];
                for (let l = 0; l < checkedKeys.length; l++) {
                    let node = this.$refs.TdTree.getNode(tag[this.defaultProps.id]);
                    if (node != null) {
                        this.getNodeSelectStatus(checkedKeys[l][this.defaultProps.id], node, childKeyMap);
                    }
                    if (checkedKeys[l][this.defaultProps.id] !== tag[this.defaultProps.id] && this.$util.isEmpty(childKeyMap.get(checkedKeys[l][this.defaultProps.id]))) {
                        checkedNodes.push(checkedKeys[l]);
                    }
                }
                this.$refs.TdTree.setCheckedNodes(checkedNodes);
                this.$emit('handleClose', tag);
            } else {
                this.$emit('handleClose', this.lastData);
                this.$nextTick(function() {
                    if (document.getElementById(this.tagId) !== null) {
                        let menuObj = document.getElementById(this.tagId).parentNode;
                        if (menuObj && menuObj.classList && menuObj.classList.length > 1) {
                            menuObj.classList = [];
                            menuObj.classList.add('el-tree-node__content');
                        }
                    }
                    this.lastData = '';
                });
            }
        },
        // 递归获取该节点是否选中
        getNodeSelectStatus(checkedKey, tag, childKeyMap) {
            if (this.$util.isEmpty(tag.data[this.defaultProps.parentId]) || '0001' == tag.data[this.defaultProps.parentId]) {
                return;
            } else if (checkedKey == tag.data[this.defaultProps.parentId]) {
                childKeyMap.set(checkedKey, false);
                return;
            } else {
                let parentNode = this.$refs.TdTree.getNode(tag.data[this.defaultProps.parentId]);
                if (this.$util.isEmpty(parentNode)) {
                    if (checkedKey == tag.data[this.defaultProps.id]) {
                        childKeyMap.set(checkedKey, false);
                        return;
                    }
                } else {
                    this.getNodeSelectStatus(checkedKey, parentNode, childKeyMap);
                }
            }
        },
        // 循环获取节点下所有子节点
        getAllChildKeys(tag, childKeyMap) {
            if (tag && tag[this.defaultProps.id]) {
                childKeyMap.set(tag[this.defaultProps.id], false);
            }
            if (tag[this.defaultProps.children]) {
                tag[this.defaultProps.children].forEach(node => {
                    this.getAllChildKeys(node, childKeyMap);
                });
            }
        },
        // 复选框发生变化时触发事件
        checkChange(data, isCheck) {
            if (isCheck) {
                let typeCoincidence = true;
                if (!this.isNeedFilter) {
                    // 过滤不需要的节点类型
                    for (let i = 0; i < this.filter.length; i++) {
                        if (data[this.filter[i].field] === this.filter[i].value) {
                            typeCoincidence = false;
                            break;
                        }
                    }
                } else {
                    // 过滤，选择需要的节点类型
                    typeCoincidence = false;
                    for (let i = 0; i < this.needFilter.length; i++) {
                        if (data[this.needFilter[i].field] === this.needFilter[i].value) {
                            typeCoincidence = true;
                            break;
                        }
                    }
                }
                if (typeCoincidence) {
                    // 标记已选中areaUserList中是否存在传入data
                    let isExit = false;
                    for (let i = 0; i < this.areaUserList.length; i++) {
                        if (this.areaUserList[i][this.defaultProps.id] == data[this.defaultProps.id]) {
                            isExit = true;
                            break;
                        }
                    }
                    if (!isExit) {
                        // 不存在则放入areaUserList中
                        this.areaUserList.push(data);
                    }
                }
            } else {
                for (let i in this.areaUserList) {
                    if (this.areaUserList[i][this.defaultProps.id] === data[this.defaultProps.id]) {
                        this.areaUserList.splice(i, 1);
                        break;
                    }
                }
            }
            this.$emit('checkChange', data, isCheck);
        },
        // 树形节点双击事件
        onDbClick(item) {
            if (this.isDbClick) {
                this.$emit('onDbClick', item);
            }
        },
        // 用于判断该节点能否被选中
        isSelect(isChosen) {
            this.isChosen = isChosen;
        },
        // 搜索属性方法
        querySearchData(params) {
            this.$emit('querySearchData', params);
        },
        setCheckedNodes(checkList) {
            this.$refs.TdTree.setCheckedNodes(checkList);
        },
        getCheckedKeys() {
            return this.$refs.TdTree.getCheckedKeys();
        },
        getHalfCheckedKeys() {
            return this.$refs.TdTree.getHalfCheckedKeys();
        },
        // 树形选中触发
        check(data, treeObj, selectKeysMap) {
            if (selectKeysMap != null && selectKeysMap.size == 0) {
                if (!this.checkStrictly && this.areaUserList && this.areaUserList.length > 0) {
                    this.areaUserList.splice(0, this.areaUserList.length);
                }
            } else {
                for (let i = 0; i < this.areaUserList.length; i++) {
                    let node = this.areaUserList[i];
                    if (!this.checkStrictly && node && node[this.defaultProps.parentId] && selectKeysMap && !selectKeysMap.get(node[this.defaultProps.parentId])) {
                        this.areaUserList.splice(i, 1);
                        i--;
                    }
                }
            }
        },
        // 单击下拉树形节点
        onClick(data) {
            /* 单选时排除不允许选中的数据 暂时注释，提测后修改*/
            // let typeCoincidence = false;
            // if (!this.isNeedFilter) {
            //     // 过滤不需要的节点类型
            //     for (let i = 0; i < this.filter.length; i++) {
            //         if (data[this.filter[i].field] === this.filter[i].value) {
            //             typeCoincidence = false;
            //             break;
            //         }
            //     }
            // } else {
            //     // 过滤，选择需要的节点类型
            //     typeCoincidence = false;
            //     for (let i = 0; i < this.needFilter.length; i++) {
            //         if (data[this.needFilter[i].field] === this.needFilter[i].value) {
            //             typeCoincidence = true;
            //             break;
            //         }
            //     }
            // }
            // if (!typeCoincidence) {
            //     return;
            // }
            this.$emit('isChosen', data);
            if (!this.multiple && this.isChosen) {
                if (this.areaUserList.length > 0) {
                    // 下拉树形点击后回显对象变为最新点击对象，在单选情况下生效
                    this.areaUserList = [data];
                    // this.areaUserList[0][this.defaultProps.label] = data[this.defaultProps.label];
                } else {
                    let datas = {};
                    for (let i in data) {
                        datas[i] = data[i];
                    }
                    this.areaUserList.push(datas);
                }
                this.tagId = data[this.defaultProps.id];
                this.$nextTick(function() {
                    if (
                        this.lastData !== '' &&
                        this.lastData[this.defaultProps.id] !== data[this.defaultProps.id] &&
                        !this.$util.isEmpty(document.getElementById(this.lastData[this.defaultProps.id]))
                    ) {
                        // 清空上次选中数据状态
                        let menuObj = document.getElementById(this.lastData[this.defaultProps.id]).parentNode;
                        if (menuObj && menuObj.classList && menuObj.classList.length > 1) {
                            menuObj.classList = [];
                            menuObj.classList.add('el-tree-node__content');
                        }
                    }
                    this.lastData = data;
                    this.$emit('clickSelect', data);
                    // 关闭下拉菜单
                    if (this.popoverShow) {
                        this.$refs.popover.doClose();
                    }
                    if (document.getElementById(data[this.defaultProps.id]) !== null) {
                        let menuObj = document.getElementById(data[this.defaultProps.id]).parentNode;
                        menuObj.classList.add('tree_select');
                    }
                    if (
                        this.lastData !== '' &&
                        this.lastData[this.defaultProps.id] !== data[this.defaultProps.id] &&
                        !this.$util.isEmpty(document.getElementById(this.lastData[this.defaultProps.id]))
                    ) {
                        let menuObj = document.getElementById(this.lastData[this.defaultProps.id]).parentNode;
                        menuObj.classList.add('tree_select_last');
                    }
                });
            }
            this.$emit('isChosenSimple', data);
        }
    }
};
</script>
<style>
.leave-message-textarea {
    cursor: pointer;
    outline: 0;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 13px;
    float: left;
    vertical-align: middle;
    background-color: #ffffff;
}
.leave-message-textarea-disabled {
    cursor: pointer;
    outline: 0;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    font-size: 13px;
    float: left;
    vertical-align: middle;
    background-color: #f5f7fa;
}
.test-1::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}
.test-1::-webkit-scrollbar-thumb {
    border-radius: 10px;
}
.test-1::-webkit-scrollbar-track {
    border-radius: 10px;
}
</style>
<style scoped>
.el-tag--medium {
    position: absolute;
    top: 5px;
    margin-left: 5px;
}
.tags-num-text {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.address-placeholder {
    color: #c0c4cc;
    padding: 0 15px;
    font-size: 13px;
    font-family: 'Microsoft Yahei', sans-serif;
    position: absolute;
    left: 0;
    top: 0;
}
>>> .el-input__validateIcon {
    display: none;
}
>>> .el-input--medium .el-input__icon {
    line-height: 34px;
}
</style>
